module.exports = __webpack_public_path__ + "static/media/19ESCAP17.83de0585.jpg";